import {CountryApiModel} from "../../common/country/models/country-api-model";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {PartialGameApiModel} from "./partial-game-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {PagingModel} from "../../../infrastructure/models/paging/paging.model";
import {BookmakerApiModel} from "../../common/bookmaker/models/bookmaker-api-model";
import {SummaryApiModel} from "../../full-game/models/summary/summary.api-model";
import {RoundFilterApiModel} from "./round-filter/round-filter.api-model";
import type {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";

export class PartialGameResponseApiModel extends BaseApiResponseModel {
  competitions: Array<CompetitionApiModel>;
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  games: Array<PartialGameApiModel>;
  bookmakers: Array<BookmakerApiModel>;
  paging: PagingModel;
  liveGamesCount: Number;
  summary: SummaryApiModel;
  suggestedGames: Array<PartialGameApiModel>;
  roundFilters: Array<RoundFilterApiModel>;
  competitionFilters: Array<CompetitionApiModel>;

  constructor(
    model: BaseApiResponseModel,
    request: BaseApiRequestModel
  ) {
    super(model, request);

    this.competitions = model?.competitions;
    this.competitors = model?.competitors;
    this.countries = model?.countries;
    this.games = model?.games;
    this.sports = model?.sports;
    this.paging = model?.paging;
    this.bookmakers = model?.bookmakers;
    this.liveGamesCount = model?.liveGamesCount;
    this.summary = model?.summary;
    this.suggestedGames = model?.suggestedGames;
    this.roundFilters = model?.roundFilters;
  }
}
